import { stringArrayToSelectOptions } from '@/utils/misc.ts';

export const Currency = {
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
  JPY: 'JPY',
  AUD: 'AUD',
  HKD: 'HKD',
  CNY: 'CNY',
  TWD: 'TWD',
  SGD: 'SGD',
};
export const CurrencyOptions = stringArrayToSelectOptions(Object.values(Currency));
